import { connect } from 'react-redux';

import SearchView from './SearchView.jsx';
import _ from "lodash";

import { 
  searchAsset, searchCollections, searchStreams, 
  searchContacts, fetchTags, invalidateAssetSearchResult,
  invalidateCollectionsSearchResult, invalidateStreamsSearchResult, 
  invalidateContactsSearchResult, invalidateTags, 
  searchContactLists, invalidateContactListsSearchResult,
  recordSearchQuery, fetchSeekQASuggestions, seekAnswerForQuestion,notifyContentModerator } from 'src/legacy/redux/actions/search.jsx';
import {invalidateSeekSession} from "src/redux/actions/seek";

import { fetchCustomFields } from 'src/legacy/redux/actions/customFields.jsx';
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import { trackAdoptionMetricsForContentSearchEvent, trackAdoptionMetricsForSearchScreenView } from 'src/legacy/redux/actions/adoption.jsx';
import { SEEK_USER_QUESTION_LIMIT_EXCEEDED } from 'src/constants/seekErrors';

const mapStateToProps = (state, ownProps) => {

  const searchableFields = (state.legacyRootReducer.settings.customFields.items || []).filter(field => {
    return field.searchable;
  });
  
  const seekErrors = _.get(state, "legacyRootReducer.search.seek.error.errors");
  const isSeekLimitExceeded = _.find(seekErrors, { code: SEEK_USER_QUESTION_LIMIT_EXCEEDED });
  const account = _.get(state, "accounts.item", {});

  return {
    account: account,
    globalContactsEnabled: account.globalContactEnabled,
    assets: state.legacyRootReducer.search.assets,
    assetsSearching: state.legacyRootReducer.search.assets.searching,
    collections: state.legacyRootReducer.search.collections,
    collectionsSearching: state.legacyRootReducer.search.collections.searching,
    streams: state.legacyRootReducer.search.streams,
    streamsSearching: state.legacyRootReducer.search.streams.searching,
    contacts: state.legacyRootReducer.search.contacts,
    contactsSearching: state.legacyRootReducer.search.contacts.searching,
    contactLists: state.legacyRootReducer.search.contactLists,
    contactListsSearching: state.legacyRootReducer.search.contactLists.searching,
    tags: state.legacyRootReducer.search.tags.item,
    totalItems: state.legacyRootReducer.search.tags.totalItems,
    fetchingTag: state.legacyRootReducer.search.tags.loading,
    customFields: searchableFields,
    seekSuggestedQuestions: _.get(state,"legacyRootReducer.search.seek.suggestions.items",[]),
    isSeekLimitExceeded: isSeekLimitExceeded ? true : false,
    seekSession: _.get(state, 'seek.session.item'),
    isSeekLoading: _.get(state, 'seek.session.loading', false),
    isNotifying: _.get(state, "legacyRootReducer.search.notifying", false),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    searchAsset: (query, filter, page, limit, highlight, searchWithinHub) => {
      return dispatch(searchAsset(query, filter, page, limit, highlight, searchWithinHub));
    },
    searchCollections: (query, page, limit, highlight) => {
      return dispatch(searchCollections(query, null, page, limit, highlight));
    },
    searchStreams: (query, filter, page, limit, highlight) => {
      return dispatch(searchStreams(query, filter, page, limit, highlight));
    },
    searchContacts: (query, global, page, limit, highlight) => {
      return dispatch(searchContacts(query, global, page, limit, highlight));
    },
    fetchTags: (query, filter) => {
      return dispatch(fetchTags(query, filter));
    },
    fetchCustomFields: () => {
      return dispatch(fetchCustomFields());
    },
    invalidateAssetSearchResult: () => {
      return dispatch(invalidateAssetSearchResult());
    },
    invalidateCollectionsSearchResult: () => {
      return dispatch(invalidateCollectionsSearchResult());
    },
    invalidateStreamsSearchResult: () => {
      return dispatch(invalidateStreamsSearchResult());
    },
    invalidateContactsSearchResult: () => {
      return dispatch(invalidateContactsSearchResult());
    },
    invalidateTags: () => {
      return dispatch(invalidateTags())
    },
    searchContactLists: (query, page, limit, highlight) => {
      return dispatch(searchContactLists(query, page, limit, highlight));
    },
    invalidateContactListsSearchResult: () => {
      return dispatch(invalidateContactListsSearchResult());
    },
    recordSearchQuery: (context) => {
      return dispatch(recordSearchQuery(context));
    },
    
    fetchSeekQASuggestions: () => {
      return dispatch(fetchSeekQASuggestions())
    },
    seekAnswerForQuestion: (session, question, assetId) => {
      return dispatch(seekAnswerForQuestion(session, question, assetId));
    },
    invalidateSeekSession: () => {
      return dispatch(invalidateSeekSession());
    },

     trackAdoptionMetricsForContentSearchEvent: (sourceCta, searchString, filter, tags, categories) => {
      return dispatch(trackAdoptionMetricsForContentSearchEvent(sourceCta, searchString, filter, tags, categories));
    },

    trackAdoptionMetricsForSearchScreenView: () => {
      return dispatch(trackAdoptionMetricsForSearchScreenView())
    },
     notifyContentModerator: (query) => {
      return dispatch(notifyContentModerator(query));
    }
  }
}

const SearchPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(SearchView);

export default withUseHooks(SearchPage);